export const SharedTypes = Object.freeze({
    SHARED: 'Shared',
    COMPANY: 'Company',
});
